<mat-card>
  <mat-card-title>Current Tests</mat-card-title>

  <table data-qa-id="feature-testing-table-tests">
    <thead>
      <tr>
        <th>
          TestId
        </th>
        <th>TestName</th>
        <th>Regex</th>
        <th>Enabled?</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (test of tests; track test) {
        <tr>
          <td>{{test.TestId}}</td>
          <td>{{test.TestName}}</td>
          <td>{{test.Regex}}</td>
          <td>{{test.TestEnabled}}</td>
          <td><button mat-raised-button [attr.data-qa-id]="'feature-testing-btn-edit-test-' + test.TestId" class="mat-accent" (click)="testBeingEdited = test;">Edit</button></td>
        </tr>
      }
    </tbody>
  </table>
  <button mat-raised-button data-qa-id="feature-testing-btn-new-test" class="mat-accent" (click)="testBeingEdited = {};">New Test</button>
</mat-card>

@if (testBeingEdited) {
  <mat-card>
    <mat-card-title>Edit Test</mat-card-title>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Test Name</mat-label>
        <input matInput data-qa-id="feature-testing-input-test-name" type="text" placeholder="Test Name" [(ngModel)]="testBeingEdited.TestName" name="testName"
          required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Regex</mat-label>
        <input matInput data-qa-id="feature-testing-input-regex" type="text" placeholder="Regex" [(ngModel)]="testBeingEdited.Regex" name="regex"
          required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Output Path to Test</mat-label>
        <input matInput data-qa-id="feature-testing-input-test-path" type="text" placeholder="TestPath" [(ngModel)]="testBeingEdited.TestPath" name="TestPath"
          required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Check every 1 in ... requests</mat-label>
        <input matInput data-qa-id="feature-testing-input-probability" type="number" placeholder="Probability" [(ngModel)]="testBeingEdited.Probability"
          name="Probability" required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Feature Flag to Test</mat-label>
        <input matInput data-qa-id="feature-testing-input-test-feature-flag" type="text" placeholder="TestFeatureFlag" [(ngModel)]="testBeingEdited.TestFeatureFlag"
          name="TestFeatureFlag" required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Feature Flag Modules to Test</mat-label>
        <input matInput data-qa-id="feature-testing-input-feature-flag-modules" type="text" placeholder="FeatureFlagModules"
          [(ngModel)]="testBeingEdited.FeatureFlagModules" name="FeatureFlagModules" required="required" />
      </mat-form-field>
    </div>
    <div>
      <mat-checkbox data-qa-id="feature-testing-checkbox-enabled" type="checkbox" placeholder="TestEnabled" [(ngModel)]="testBeingEdited.TestEnabled"
      name="TestEnabled" required="true">Enabled</mat-checkbox>
    </div>
    <button mat-raised-button data-qa-id="feature-testing-btn-save-changes" class="mat-accent" (click)="save(testBeingEdited);">Save Changes</button>
    <button mat-button data-qa-id="feature-testing-btn-cancel" class="mat-accent" (click)="testBeingEdited = undefined;">Cancel</button>
  </mat-card>
}